import { Services } from '@sigma-frontend-libs/commons'

import { components, labelModes, proxy, sizes } from '@/utils'

import render from './render'

export default {
  name: 'SelectorSendingType',

  mixins: [ proxy() ],

  props: {
    permission: String,
    label: String,
    hint: String,
    error: String,
    titlePrefix: String,
    valuePrefix: String,

    items: {
      type: Array,
      default: () => {
        return []
      }
    },
    itemsPrepend: {
      type: Array,
      default: () => {
        return []
      }
    },
    itemsAppend: {
      type: Array,
      default: () => {
        return []
      }
    },
    itemsDisabled: {
      type: Array,
      default: () => {
        return []
      }
    },

    loading: Boolean,
    disabled: Boolean,
    required: Boolean,
    readonly: Boolean,
    multiple: Boolean,
    cancelable: Boolean,

    dense: {
      type: Boolean,
      default: true
    },
    clearable: {
      type: Boolean,
      default: true
    },

    size: {
      type: String,
      default: sizes.medium,
      validator: value => {
        return Object.values(sizes).includes(value)
      }
    },
    labelMode: {
      type: String,
      default: labelModes.hidden,
      validator: value => {
        return Object.values(labelModes).includes(value)
      }
    },
    view: {
      type: String,
      default: components.select,
      validator: value => {
        return [ components.select, 'buttons' ].includes(value)
      }
    }
  },

  computed: {
    $items() {
      const result = []

      if (this.itemsPrepend.length) {
        result.push(...this.itemsPrepend)
      }
      if (this.items.length) {
        result.push(...this.items)
      } else {
        result.push(...this.getSendingTypesByPermission(this.permission))
      }
      if (this.itemsAppend.length) {
        result.push(...this.itemsAppend)
      }

      return result.map(item => {
        const value = item.value ?? item

        return {
          value,
          title: item.title ?? this.getTranslate(`${Services.sendings}.types.${item}`),
          type: item.type ?? item,
          iconSVG: item.type ?? item,
          iconColor: item.type ?? item,
          disabled: this.itemsDisabled.includes(value)
        }
      })
    },

    $clearable() {
      if (this.required) {
        return false
      }

      return this.clearable
    }
  },

  methods: {
    proxyHasValue(value) {
      if (Array.isArray(this.proxy) && this.proxy.length) {
        return this.proxy.includes(value)
      } else {
        return this.proxy === value
      }
    },

    eventHandler(value) {
      if (!this.readonly && !this.disabled) {
        if (this.multiple) {
          if (Array.isArray(this.proxy)) {
            const index = this.proxy.findIndex(item => {
              return item === value
            })
            if (index > -1) {
              this.proxy.splice(index, 1)
            } else {
              this.proxy.push(value)
            }
          }
        } else {
          this.proxy = value
        }
      }
    }
  },

  render
}
